<template>
  <TabBtn
    :tabs="tabs"
    :active-tab="currentTab.value"
    height="600px"
    @tab-click="handleTabClick"
  >
    <template slot="btn">
      <el-button type="primary" size="mini" @click="handleCalculate"
        >测算最新含量</el-button
      >
      <el-button type="primary" size="mini" @click="handleInsert"
        >带入企业定额库</el-button
      >
      <el-button
        v-if="currentTab.value === 'historyDataReal'"
        type="primary"
        size="mini"
        @click="handleImportReal"
        >导入实耗人材机</el-button
      >
    </template>
    <template>
      <div class="box">
        <div class="top" v-if="currentTab.value === 'historyDataSub'">
          <SimpleTable
            width="300px"
            table-code="QuotaHistoryLeft"
            ref="QuotaHistoryLeft"
            :showIndex="false"
            :menus="['查询', '批量修改', '批量删除', '插入']"
            :menusMergeAfter="menusMergeAfter"
            :loading="loading.left"
            :columns="columns.left"
            :data="tableData.left"
            @row-select="handleRowSelectLeft"
            @modify-data-change="handleModifyDataChangeLeft"
          />
          <SimpleTable
            table-code="QuotaHistoryRight"
            ref="QuotaHistoryRight"
            :showIndex="false"
            :loading="loading.right"
            :columns="columns.right"
            :data="tableData.right"
            @row-select="handleRowSelectRight"
          />
        </div>
        <div class="bottom">
          <SimpleTable
            :showIndex="false"
            :loading="loading.bottom"
            :columns="columns.bottom"
            :data="tableData.bottom"
          />
        </div>
      </div>
    </template>
  </TabBtn>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import { sortRecords, addCbFn, handleImport } from '@/utils/index'

export default {
  name: 'ImportQuota',
  inject: ['detailsVm'],
  components: {
    SimpleTable,
    TabBtn
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tabs: [
        {
          label: '历史工程结算子目',
          value: 'historyDataSub',
          url: '/enterprise-quota-library/history-data/item-resource/tree',
          columns: [
            { field: 'code', title: '编码', tree: true },
            { field: 'type', title: '类别' },
            { field: 'name', title: '人材机名称' },
            { field: 'spec', title: '规格型号' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '预算数量' },
            { field: 'sourceContent', title: '原有含量' },
            { field: 'newestContent', title: '最新含量' },
            { field: 'keywords', title: '预算关键词' }
          ]
        },
        {
          label: '历史工程结算人材机',
          value: 'historyDataPerson',
          url: '/enterprise-quota-library/history-data/resource/list',
          columns: [
            { field: 'name', title: '人材机名称' },
            { field: 'spec', title: '规格型号' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '预算数量' },
            { field: 'keywords', title: '预算关键词' },
            { field: 'actualName', title: '实耗人材机名称' },
            { field: 'actualSpec', title: '实耗规格型号' },
            { field: 'actualQuantity', title: '实耗数量' },
            { field: 'actualKeywords', title: '实际关键词' },
            { field: 'actualQuantityDiff', title: '实耗量增减系数' }
          ]
        },
        {
          label: '历史工程实耗人材机',
          value: 'historyDataReal',
          url: '/enterprise-quota-library/actual-resource/list',
          columns: [
            { field: 'code', title: '编码', tree: true },
            { field: 'name', title: '人材机名称' },
            { field: 'spec', title: '规格型号' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '实耗数量' },
            { field: 'keywords', title: '实耗关键词' }
          ]
        }
      ],
      currentTab: {},
      loading: {
        left: false,
        right: false,
        bottom: false
      },
      tableData: {
        left: [],
        right: [],
        bottom: []
      },
      columns: {
        left: [
          {
            field: 'historyDataName',
            title: '历史工程名称',
            canModify: true,
            editModal: {
              columns: [{ field: 'name', title: '历史工程名称', tree: true }],
              options: async () => {
                const res = await this.$service.get('/history-data-budget/list')
                return sortRecords(res?.data || [])
              },
              confirm: (selectedCellInfos, res) => {
                const row = res[0][0].originData
                selectedCellInfos.forEach(cells => {
                  const obj = cells[0].originData
                  this.$set(obj, 'historyDataName', row.name)
                  this.$set(obj, 'hdbId', row.id)
                })
              }
            }
          }
        ],
        right: [
          { field: 'code', title: '编码' },
          { field: 'name', title: '子目名称' },
          { field: 'unit', title: '单位' },
          { field: 'quantity', title: '工程量' }
        ],
        bottom: []
      }
    }
  },
  watch: {
    basicInfo: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    }
  },
  created() {
    this.handleTabClick(this.tabs[0])
  },
  methods: {
    init() {
      if (!this.basicInfo?.id || !this.currentTab?.value) return
      if (this.currentTab.value === 'historyDataSub') {
        this.getTableDataLeft()
      } else {
        this.getTableDataBottom()
      }
    },

    handleTabClick(tab) {
      this.currentTab = tab
      this.columns.bottom = tab.columns
      this.init()
    },

    menusMergeAfter(contextMenuMap) {
      contextMenuMap['插入'] = () => this.handleInsertHistory()
    },

    async handleInsertHistory() {
      const res = await this.$service.get('/history-data-budget/list')
      const options = sortRecords(res?.data || [])

      this.$selectModal({
        title: '历史工程名称',
        key: 'historyDataName',
        width: '400px',
        allowMultiSelect: true,
        columns: [{ field: 'name', title: '历史工程名称', tree: true }],
        options,
        // confirm: (selectedCellInfos, res) => {

        // },

        confirm: (selectedCellInfos, tableData) => {
          const rows = selectedCellInfos.map(e => e[0].originData)
          const list = rows.map(e => ({
            historyDataName: e.name,
            hdbId: e.id
          }))
          this.$refs.QuotaHistoryLeft.handleInsert(list)
        }
      })
    },

    async getTableDataLeft() {
      this.tableData.left = []
      this.tableData.right = []
      this.tableData.bottom = []
      this.loading.left = true
      const res = await this.$service.get(
        '/enterprise-quota-library/history-data/list',
        { eqlId: this.basicInfo.id }
      )
      this.tableData.left = sortRecords(res.data || [])
      this.loading.left = false
      this.$refs.QuotaHistoryLeft.initialized(0, 1)
    },
    async getTableDataRight(obj) {
      this.tableData.right = []
      this.tableData.bottom = []
      if (!obj?.id) return
      this.loading.right = true
      const res = await this.$service.get(
        '/enterprise-quota-library/history-data/item/list',
        { hdbId: obj.id }
      )
      this.tableData.right = sortRecords(res.data || [])
      this.loading.right = false
      this.$refs.QuotaHistoryRight.initialized(0, 1)
    },
    async getTableDataBottom(obj) {
      this.tableData.bottom = []
      this.loading.bottom = true
      const res = await this.$service.get(this.currentTab.url, {
        itemId: obj?.id,
        eqlId: this.basicInfo.id
      })
      this.tableData.bottom = sortRecords(res.data || [])
      this.loading.bottom = false
    },

    async handleModifyDataChangeLeft(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/enterprise-quota-library/history-data/batch',
        getModifyData,
        cleanModifyData,
        arr => arr.map(e => ({ ...e, eqlId: this.basicInfo.id }))
      )
      this.getTableDataLeft()
    },

    handleRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableDataRight(obj)
    },

    handleRowSelectRight(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableDataBottom(obj)
    },

    async handleCalculate() {
      this.detailsVm.loading = true
      const res = await this.$service.post(
        `/enterprise-quota-library/calculate/latest-content/${this.basicInfo.id}`,
        { eqlId: this.basicInfo.id }
      )
      this.detailsVm.loading = false
      if (res.code === 200) this.init()
    },
    async handleInsert() {
      this.detailsVm.loading = true
      const res = await this.$service.post(
        `/enterprise-quota-library/quota-resource/enterprise-content/sync/${this.basicInfo.id}`,
        { eqlId: this.basicInfo.id }
      )
      this.detailsVm.loading = false
      if (res.code === 200) this.init()
    },
    async handleImportReal() {
      await handleImport({
        vm: this,
        id: this.basicInfo.id,
        accept: '.xlsx,.xls',
        multiple: false,
        uploadFn: this.uploadFileReal
      })
    },
    async uploadFileReal(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('eqlId', this.basicInfo.id)
      const res = await this.$service.post(
        '/enterprise-quota-library/actual-resource/import',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
      if (res.code === 200) {
        this.$message.success('导入成功')
        this.getTableDataBottom()
      }
    }
  }
}
</script>

<style scoped lang="less">
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  > div {
    flex: 1;
    width: 100%;
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
